import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { BlogList, BlogHero, BlogCard } from "@grandvisionhq/content";
import { useIntl } from "@grandvisionhq/state";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachArticles } from "../../../../hooks/hooks/use-bloomreach-articles.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsBlogOverviewItem = ({ content }) => {
  const { locale, getLabel } = useIntl();
  const { title, coverImage, readingTime, publishDate, summary, url } = content;
  const [link] = useBloomreachLinks([{ url: url ?? "#" }]);
  const image = parseBloomreachImage(coverImage);
  return /* @__PURE__ */ React.createElement(
    BlogCard,
    {
      url: link.url,
      title,
      summary,
      readingTime,
      publishDate,
      image: image?.original,
      mobileImage: image?.mobile,
      locale,
      minutesLabel: getLabel("blog.minutesToRead")
    }
  );
};
const CmsBlogHero = ({ content }) => {
  const { getLabel } = useIntl();
  const { coverImage, title, url, summary } = content;
  const [link] = useBloomreachLinks([{ url: url ?? "#" }]);
  const image = parseBloomreachImage(coverImage);
  if (!content || !image) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    BlogHero,
    {
      title,
      link: link.url,
      summary,
      image: image.original,
      mobileImage: image.mobile,
      readMoreLabel: getLabel("blog.readArticle")
    }
  );
};
const CmsBlogOverview = ({ component, page }) => {
  const { getLabel } = useIntl();
  const { title = "Blog" } = component.getParameters();
  const { loading, error, result, loadNextPage } = useBloomreachArticles({
    component,
    page
  });
  if (error) {
    console.error("CmsBlogOverview: Failed to fetch more articles from Bloomreach.", error);
  }
  const { highlighted, paged } = result;
  const { currentPage, nextPage, totalPages } = paged;
  const hasMoreItems = nextPage !== null && nextPage !== currentPage && nextPage <= totalPages;
  if (!paged.items) {
    console.error("CmsBlogOverview: No blog items found to render.");
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, highlighted && /* @__PURE__ */ React.createElement(CmsBlogHero, { content: highlighted }), /* @__PURE__ */ React.createElement(BlogList, { title, noArticlesLabel: getLabel("blog.noArticles") }, paged.items.map((item) => item && /* @__PURE__ */ React.createElement(CmsBlogOverviewItem, { key: item.id, content: item }))), hasMoreItems && /* @__PURE__ */ React.createElement("div", { className: "blog-list__show-more" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "blog-list__button",
      variant: "outline",
      color: "primary",
      isLoading: loading,
      href: `?page=${result.paged.nextPage}`,
      onClick: (e) => {
        e.preventDefault();
        loadNextPage();
        if (result.paged.nextPage) {
          const url = new URL(window.location.href);
          url.searchParams.set("page", result.paged.nextPage.toString());
          window.history.pushState({}, "", url);
        }
      },
      caption: getLabel("blog.articles.showMore")
    }
  )));
};
const BlogOverview = compose(
  withBreakpointVisibility,
  withAnchor
)(CmsBlogOverview);
export {
  CmsBlogHero,
  CmsBlogOverview,
  CmsBlogOverviewItem,
  BlogOverview as default
};
//# sourceMappingURL=BlogOverview.js.map
